import { useQuery } from '@tanstack/react-query';

// New response format from API
interface PageContentResponse {
  pageSlug: string;
  sections: Record<
    string,
    {
      type: string;
      value: string;
      updatedAt: string;
    }
  >;
  metadata: {
    sectionCount: number;
    lastUpdated: string;
  };
}

export function usePageContent(pageSlug: string) {
  const { data, isLoading } = useQuery<PageContentResponse>({
    queryKey: ['/api/content', pageSlug],
    enabled: !!pageSlug,
  });

  // Helper function to get content by section key
  const getContent = (sectionKey: string, fallback = '') => {
    if (!data?.sections) return fallback;
    return data.sections[sectionKey]?.value || fallback;
  };

  return {
    content: data,
    sections: data?.sections || {},
    isLoading,
    getContent,
  };
}
